import { useEffect } from 'react';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import '@/App.css';
import { Header } from '@/components/Header';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { Banks } from '@/components/Banks';
import { Loans } from '@/components/Loans';
import { Insurance } from '@/components/Insurance';
import { Process } from '@/components/Process';
import { Calculator } from '@/components/Calculator';
import { EnquiryForm } from '@/components/EnquiryForm';
import { FloatingCTA } from '@/components/FloatingCTA';
import { Footer } from '@/components/Footer';

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        const onAnchor = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const target = document.querySelector(a.getAttribute('href'));
            if (target) {
                e.preventDefault();
                lenis.scrollTo(target, { offset: -72 });
            }
        };
        document.addEventListener('click', onAnchor);
        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener('click', onAnchor);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App" data-testid="prem-associates-app">
            <div className="noise-overlay" />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Loans />
                <Process />
                <EnquiryForm />
                <Calculator />
                <Banks />
                <Insurance />
            </main>
            <Footer />
            <FloatingCTA />
            <Toaster position="top-center" richColors theme="dark" />
        </div>
    );
}

export default App;
